module.exports = __webpack_public_path__ + "static/media/logo_on_blue_bg_mobile.4b75323b.png";